<template>
  <div>
    <template v-for="field in fields">
      <slot :field="field" :error="hasErrors(field.id)" :error-messages="getErrors(field.id)" :name="`field${fieldUCFirst(field)}`">
          <component
            :key="field.id"
            :is="getFieldComp(field.comp)"
            v-bind="field.props"
            v-if="field.when === undefined ? true : field.when"
            v-model="object[field.id]"
            @input="delete errors[field.id]"
            @change="delete errors[field.id]"
            :label="field.label"
            :error="hasErrors(field.id)"
            :error-messages="getErrors(field.id)"
          />
        </component>
      </slot>
    </template>
  </div>
</template>
<script>
import VTextField from 'vuetify/es5/components/VTextField'
import VTextarea from 'vuetify/es5/components/VTextarea'
import VSelect from 'vuetify/es5/components/VSelect'
import VCheckbox from 'vuetify/es5/components/VCheckbox'
import InputDate from './InputDate'
import {camelCase, upperFirst} from 'lodash'

export default {
  props: {
    fields: Array,
    object: Object,
    errors: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    fieldUCFirst (field) {
      return upperFirst(camelCase(field.id))
    },
    getFieldComp (comp) {
      if ((typeof comp) === 'string') {
        switch (comp) {
          case 'date':
            return InputDate
          case 'textarea':
            return VTextarea
          case 'text':
            return VTextField
          case 'select':
            return VSelect
          case 'file':
            // return InputFile
            return VTextField
          case 'checkbox':
            return VCheckbox
        }
      }
      return comp
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    getErrors (name) {
      return this.errors[name] || []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/Fields.vue